import { render } from "./AddStatementModal.vue?vue&type=template&id=3482f4cb&scoped=true"
import script from "./AddStatementModal.vue?vue&type=script&lang=js"
export * from "./AddStatementModal.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./AddStatementModal.vue?vue&type=style&index=1&id=3482f4cb&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3482f4cb"]])

export default __exports__